<template>
  <header class="header-main">
    <div class="header-main__logo-search-block" @click="onClickLogoSearchBlock">
      <div class="logo">聚搜</div>
      <div :class="searchValue ? 'search value' : 'search'">
        {{ searchValue || "请输入搜索关键词" }}
      </div>
    </div>
    <van-overlay :show="overlayVisible" class="header-main__overlay">
      <div class="search-wrapper">
        <van-icon
          name="arrow-left"
          size="20"
          class="back-icon"
          @click="overlayVisible = false"
        />
        <van-search
          :value="innerSearchValue"
          :show-action="true"
          :autofocus="true"
          placeholder="请输入搜索关键词"
          class="search-input"
          @input="onInputSearchValue"
          @search="onSearch"
        >
          <template #action>
            <div @click="onClickSearchAction">搜索</div>
          </template>
        </van-search>
      </div>
    </van-overlay>
  </header>
</template>

<script>
export default {
  name: "HeaderMain",
  props: {
    searchValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      overlayVisible: false,
      innerSearchValue: "",
    };
  },
  methods: {
    onInputSearchValue(value) {
      this.innerSearchValue = value;
    },
    onClickLogoSearchBlock() {
      this.innerSearchValue = this.searchValue;
      this.overlayVisible = true;
    },
    onSearch(value) {
      this.$emit("update:searchValue", value);
      this.overlayVisible = false;
    },
    onClickSearchAction() {
      const { innerSearchValue } = this;
      this.$emit("update:searchValue", innerSearchValue);
      this.overlayVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-main {
  padding: 10px 12px;

  .header-main__logo-search-block {
    display: flex;
    align-items: center;
    background-color: #f7f8fa;

    .logo {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3em;
      height: 34px;
      background-color: #581c87;
      border-radius: 2px 0 0 2px;
      font-size: 18px;
      color: #fff;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: -4px;
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 34px 4px 0 0;
        border-color: #581c87 transparent transparent transparent;
      }
    }

    .search {
      padding-left: 1em;
      display: flex;
      align-items: center;
      flex-grow: 1;
      color: #cac9cc;

      &.value {
        color: #323233;
      }
    }
  }

  .header-main__overlay {
    .search-wrapper {
      display: flex;
      align-items: center;
      background-color: #fff;

      .back-icon {
        padding-left: 16px;
      }

      .search-input {
        padding-right: 12px;
        flex-grow: 1;
      }
    }
  }
}

@media screen and (min-width: 992px) {
  .header-main {
    display: none;
  }
}
</style>